export const START_WORKOUT = 'startWorkout';

export const SHOW_MEAL_CONFIRM = 'mealConfirm';
